import { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import CanvasAddProductButton from "../../../sharable/CanvasAddProductButton";
import EncarteProduct from "../../../sharable/EncarteProduct/EncarteProduct";
import EncarteTrialVersionMarketingMessage from "../../../sharable/EncarteTrialVersionMarketingMessage";
import FooterStyles, {
  getPanfletoFooterRowHeight,
  useFooterNotice,
} from "../../../sharable/SocialCanvasFooterStyles";
import { BRAND_VIEW } from "../../ToolBarMenuViews/Toolbar";
import WorkspaceContext from "../../WorkspaceContext";
import {
  BrandLogo,
  calcProductStylesOcurrence,
  Canvas,
  GridProducts,
  Header,
} from "../Canvas/CanvasGeneralStyles";
import {
  CANVAS_TARGET_CLASSNAME,
  LOGO_SIZE_MEDIUM,
  PANFLETO_DIM,
} from "../EncarteConstants";

const PanfletoCanvasContainer = styled(Canvas)`
  ${({ canvasScale, styles }) => css`
    background-position-y: ${-300 * canvasScale}px;
    .marketing-message {
      font-size: ${26 * canvasScale}px;
    }
  `}
`;
const PanfletoHeader = styled(Header)``;
const PanfletoGridProducts = styled(GridProducts)``;

export default function PanfletoCanvas({
  grid,
  products,
  canvasScale,
  isProductClickable,
}) {
  const { styles, userBrand, encarte, model, scrollIntoMenu } =
    useContext(WorkspaceContext);
  const [headerAndFooterStyles, setHeaderAndFooterStyles] = useState(undefined);

  useEffect(() => {
    if (products?.length === 0) {
      setHeaderAndFooterStyles(null);
      return;
    }
    setHeaderAndFooterStyles(calcProductStylesOcurrence(products));
  }, [products]);

  const footerNotice = useFooterNotice();
  const footerRowHeight = getPanfletoFooterRowHeight(
    styles.footerStyle,
    canvasScale,
    Boolean(footerNotice),
  );

  return (
    <PanfletoCanvasContainer
      canvasScale={canvasScale}
      styles={styles}
      model={model}
      dimensions={PANFLETO_DIM}
      className={CANVAS_TARGET_CLASSNAME}
      footerRowHeight={footerRowHeight}
    >
      <PanfletoHeader styles={styles} canvasScale={canvasScale}>
        <BrandLogo
          logo={userBrand.logoURLTmp}
          canvasScale={canvasScale}
          logoSize={styles.logoSize}
          logoStyle={styles.logoStyle}
          headerStyles={headerAndFooterStyles}
          position={{ bottom: 15, right: 10 }}
          size={LOGO_SIZE_MEDIUM}
          onClick={() => {
            if (isProductClickable) scrollIntoMenu(BRAND_VIEW);
          }}
        />
      </PanfletoHeader>
      {grid && products?.length > 0 ? (
        <>
          <PanfletoGridProducts
            grid={grid}
            styles={styles}
            canvasScale={canvasScale}
          >
            {products.map((product, i) => (
              <EncarteProduct
                product={product}
                canvasScale={canvasScale}
                styles={styles}
                index={i}
                isProductClickable={isProductClickable}
                productsLength={products.length}
              />
            ))}
          </PanfletoGridProducts>
          {/* <EncarteTrialVersionMarketingMessage
            canvasScale={canvasScale}
            className="marketing-message"
          /> */}
        </>
      ) : (
        <CanvasAddProductButton dimensions={PANFLETO_DIM} />
      )}
      {headerAndFooterStyles && (
        <FooterStyles
          headerAndFooterStyles={headerAndFooterStyles}
          canvasScale={canvasScale}
        />
      )}
    </PanfletoCanvasContainer>
  );
}
